import { render, staticRenderFns } from "./AcceptJob.vue?vue&type=template&id=715e34ea"
import script from "./AcceptJob.vue?vue&type=script&lang=js"
export * from "./AcceptJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports